module.exports = __webpack_public_path__ + "img/userAppointRes_b.493f3478.png";